import * as React from "react";

type LineLoginSignupSession = {
  id: string;
  email?: string;
};

type LineLoginSignupSessionContext = {
  session?: LineLoginSignupSession;
  setSession: (s: LineLoginSignupSession) => void;
};

const LineSignupSessionContext =
  React.createContext<LineLoginSignupSessionContext>({
    session: undefined,
    setSession: () => {},
  });

export const LineSignupSessionContextProvider = ({ ...props }) => {
  const [session, _setSession] = React.useState<
    LineLoginSignupSession | undefined
  >(undefined);

  const setSession = React.useCallback(
    (s: LineLoginSignupSession) => _setSession(s),
    [_setSession],
  );

  return (
    <LineSignupSessionContext.Provider value={{ session, setSession }}>
      {props.children}
    </LineSignupSessionContext.Provider>
  );
};

export const useLineSignupSessionContext: () => LineLoginSignupSessionContext =
  () => React.useContext(LineSignupSessionContext);
